import { CollectionModelType } from '@teinor/erp/types/company/product/collection'
import ModalCECollection from './ModalCECollection'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { DeleteRow, EditRowNotLink } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import ModalDeleteCollection from './ModalDeleteCollection'

interface CollectionsProps extends ComponentWithPermissions { }

const Collections: React.FC<CollectionsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('collections', 'Colecciones'),
        newText: t('newCollection', 'Nueva colección')
    }

    return (
        <BaseScreenTable TableComponent={TableCollections} CreateModalComponent={ModalCECollection} EditModalComponent={ModalCECollection} DeleteModalComponent={ModalDeleteCollection} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableCollectionsProps extends TableComponentProps { }

const TableCollections: React.FC<TableCollectionsProps> = ({ userPermissions, setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<CollectionModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='collections' getDataFrom='/api/app/product/collection/getAllCollections' setTableInstance={setTableInstance} />
    )
}

export default Collections